import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Styles from './styled';
import Dropdown from '../Inputs/Dropdown';
import Link from '../Link';
import CardCoupon from '../CardCoupon';
import coupons from '../../../data/coupons';

const addresses = {
  TX: {
    name: 'Vanderbilt Mortgage and Finance, Inc.',
    address1: 'PO Box 660180',
    address2: 'Dallas, TX 75266-0180',
    url: '/payment-options/coupon-book-tx.pdf',
  },
  NC: {
    name: 'Vanderbilt Mortgage and Finance, Inc.',
    address1: 'PO Box 71096',
    address2: 'Charlotte, NC 28272-1096',
    url: '/payment-options/coupon-book-nc.pdf',
  },
};

const states = coupons.map(({ label }) => ({
  label,
  value: label,
}));

const Component = ({}) => {
  const [state, setState] = useState('');
  const [coupon, setCoupon] = useState(false);

  const handleChange = ({ value }) => {
    setState(value);
    const coupon = coupons.find(
      ({ label: couponValue }) => couponValue === value
    );
    setCoupon(addresses[coupon.document]);
  };

  return (
    <Styles className='coupon_search'>
      <section className='search'>
        <form>
          <Dropdown
            label='State'
            name='state'
            value={state}
            values={states}
            onChange={handleChange}
          />
        </form>
      </section>
      <section className='result'>
        {coupon && (
          <CardCoupon url={coupon.url}>
            <p>
              {coupon.name}
              <br />
              {coupon.address1}
              <br />
              {coupon.address2}
            </p>
          </CardCoupon>
        )}
      </section>
    </Styles>
  );
};

Component.propTypes = {};

export default Component;
